(()=>{
function init(root){if(!root||root.dataset.ritualReady)return;root.dataset.ritualReady='true';
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
if ('IntersectionObserver' in window && !reduceMotion.matches) {
  root.classList.add('js-reveal');
  const reveal = new IntersectionObserver(entries => {
    entries.forEach(entry => {if (entry.isIntersecting) {entry.target.classList.add('is-visible'); reveal.unobserve(entry.target);}});
  }, {threshold: .12});
  root.querySelectorAll('.reveal').forEach(el => reveal.observe(el));
}
const hero = root.querySelector('#ritual-hero'), heroControl = root.querySelector('#hero-control');
hero.muted = true;
heroControl.addEventListener('click', async () => {
  if (!hero.paused) {hero.pause(); return;}
  if (hero.ended) hero.currentTime = 0;
  try {await hero.play();} catch {hero.controls = true;}
});
hero.addEventListener('play', () => heroControl.textContent = 'Pause Ⅱ');
hero.addEventListener('pause', () => heroControl.textContent = hero.ended ? 'Replay ↻' : 'Play film ↗');
hero.addEventListener('ended', () => heroControl.textContent = 'Replay ↻');
if ('IntersectionObserver' in window && !reduceMotion.matches) {
 const once = new IntersectionObserver(entries => {if(entries.some(e=>e.isIntersecting)){once.disconnect(); hero.play().catch(()=>{});}}, {threshold:.35}); once.observe(hero);
}

// Fixed product photograph; mica, wood and illustrative smoke share one heat position.
const photoHeat=root.querySelector('#photo-heat');
if(photoHeat){
 const moving=root.querySelector('#photo-mica-moving'),meter=root.querySelector('#photo-heat-meter'),pause=root.querySelector('#photo-heat-pause');
 const smoke=root.querySelector('#photo-wood-smoke'),wisps=Array.from(smoke.querySelectorAll('path'));
 const resin=root.querySelector('#photo-resin-bubbles'),bubbles=Array.from(resin.children),bubbleSpots=[[-13,-8],[21,9]];
 let raf=0,visible=false,paused=reduceMotion.matches,last=0,elapsed=0;
 function draw(){const t=(elapsed/1000)%10;const p=t<2?0:t<5?(1-Math.cos(Math.PI*(t-2)/3))/2:t<7?1:(1+Math.cos(Math.PI*(t-7)/3))/2;
 moving.setAttribute('transform',`translate(0 ${170*p})`);const cool=p>.5;photoHeat.dataset.temperature=cool?'cool':'warm';meter.style.setProperty('--position',`${p*100}%`);meter.setAttribute('aria-valuenow',String(Math.round(p*100)));meter.setAttribute('aria-valuetext',p<.1?'Warmer':p>.9?'Cooler':'Moving between warmer and cooler');
 // Bubbles are attached to the wood and subside before the cooler resting position.
 resin.setAttribute('transform',`translate(${420+170*p} 688)`);
 const bubbling=Math.max(0,1-p/.85);resin.setAttribute('opacity',String(bubbling));
 bubbles.forEach((b,i)=>{const cycle=(elapsed/1000*(.65+i*.04)+i*.173)%1,radius=(1.6+3.1*Math.sin(Math.PI*cycle))*bubbling;
 b.setAttribute('transform',`translate(${bubbleSpots[i][0]} ${bubbleSpots[i][1]}) scale(1 .72)`);b.setAttribute('opacity',String(.15+.65*Math.sin(Math.PI*cycle)));
 b.children[0].setAttribute('r',String(radius));b.children[1].setAttribute('d',`M ${-.65*radius} 0 Q ${-.7*radius} ${-.7*radius} 0 ${-.7*radius}`);});
 // Same position drives the plume origin and density; no independent animation clock.
 smoke.setAttribute('transform',`translate(${420+170*p} 688)`);
 smoke.setAttribute('opacity',String(.06+.70*(1-p)));
 wisps.forEach((w,i)=>{const height=(132+i*20)*(1-.32*p),phase=elapsed/1000*1.5+i*2.1;let path='M 0 0';
 for(let j=1;j<=24;j++){const f=j/24,y=-height*f,x=Math.sin(f*7-phase)*18*f+Math.sin(f*12+phase*.6)*7*f+(i-1)*11*f;path+=` L ${x.toFixed(2)} ${y.toFixed(2)}`;}
 w.setAttribute('d',path);w.setAttribute('opacity',String(i===0?1:i===1?.65:.35));});} 
 function stop(){cancelAnimationFrame(raf);raf=0;last=0;}
 function tick(now){if(!visible||paused||document.hidden){stop();return;}if(last)elapsed+=Math.min(now-last,100);last=now;draw();raf=requestAnimationFrame(tick);}
 function sync(){stop();pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Play heat animation':'Pause heat animation');pause.setAttribute('aria-pressed',String(paused));if(visible&&!paused&&!document.hidden)raf=requestAnimationFrame(tick);}
 pause.addEventListener('click',()=>{paused=!paused;sync();});
 reduceMotion.addEventListener('change',()=>{paused=reduceMotion.matches;sync();});
 document.addEventListener('visibilitychange',sync);
 if('IntersectionObserver' in window){new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.35}).observe(photoHeat);}else{visible=true;sync();}
 draw();sync();
}

}
init(document.querySelector('#oudism-ritual-guide'));
document.addEventListener('shopify:section:load',e=>{const root=e.target.querySelector('#oudism-ritual-guide');if(root)init(root);});
})();
